export const ALERT_RATING_TYPES = [
  {
    name: 'All',
    callsign: 'ALL',
  },
  {
    name: 'Negative',
    callsign: 'NEGATIVE',
  },
  {
    name: 'Positive',
    callsign: 'POSITIVE',
  },
]

export default ALERT_RATING_TYPES
